import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { ContractSignatory } from "@academy-context/shared/domain/types/contract-signatory";
import { useContractSignatorySubmit } from "../hooks/use-contract-signatory-submit";
import { ContractSignatoryForm } from "./contract-signatory-form.content";
import {
  contractSignatoryFormSchema,
  formatSignatoryToFormData,
  type ContractSignatoryFormInputs,
} from "../form-validation/contract-signatory-form.schema";

interface Props {
  legalRepresentative: { firstName: string; lastName: string };
  providerEmail: string;
  currentSignatory: Nullable<ContractSignatory>;
  onContractInitialized: () => void;
}

export const ContractSignatoryFormContainer = ({ legalRepresentative, providerEmail, currentSignatory, onContractInitialized }: Props) => {
  const form = useForm<ContractSignatoryFormInputs>({
    resolver: yupResolver(contractSignatoryFormSchema),
    defaultValues: formatSignatoryToFormData(currentSignatory),
  });
  const { initialize } = useContractSignatorySubmit(form, onContractInitialized);

  return (
    <ContractSignatoryForm
      legalRepresentative={legalRepresentative}
      providerEmail={providerEmail}
      form={form}
      onSubmit={form.handleSubmit(initialize)}
    />
  );
};
